import { BitbotLogoWithText, BitkitButton, useResponsive } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { SystemStyleObject, useRecipe } from '@chakra-ui/react/styled-system';
import { Text } from '@chakra-ui/react/text';

import InternalFooter from '@/components/InternalFooter/InternalFooter';
import ContentWrapper from '@/components/page/ContentWrapper';
import Page, { PageProps } from '@/components/page/Page';
import { logInPath, signUpPath } from '@/utils/monolithApiRouteService';

const logInButton: SystemStyleObject = {
  color: 'text/on-color',
  textDecoration: 'none',
  _hover: { background: 'color/white/20' },
  _focusVisible: { background: 'color/white/30' },
  _active: { background: 'color/white/40' },
};

const PublicBuildHeader = () => {
  const buttonRecipe = useRecipe({ key: 'button' });

  return (
    <Box as="header" className="page-header" position="sticky" top="0" left="0" right="0" zIndex="300">
      <Box paddingY="16" background="linear-gradient(88.41deg, #760FC3 0%, #0DD3C5 100%)">
        <ContentWrapper display="flex" alignItems="center" justifyContent="space-between">
          <BitbotLogoWithText color="icon/on-color" />
          <Box display="flex" gap="12">
            {/* TODO: We will have a dedicated HeaderButton in Bitkit v2, change this to that when it is available */}
            <Box asChild css={[buttonRecipe({ size: 'sm', variant: 'tertiary' }), logInButton]}>
              <a href={`${logInPath()}?sign_in_redirect=${window.location.pathname}`} target="_blank" rel="noreferrer">
                Log in
              </a>
            </Box>
            <BitkitButton variant="secondary" href={signUpPath()} target="_blank" size="sm">
              Sign up
            </BitkitButton>
          </Box>
        </ContentWrapper>
      </Box>
    </Box>
  );
};

const PublicBuildBanner = () => {
  const { isMobile } = useResponsive();
  return (
    <Box
      color="text/on-color"
      paddingTop="8"
      paddingBottom="24"
      background="linear-gradient(88.41deg, #760FC3 0%, #0DD3C5 100%)"
    >
      <ContentWrapper display="flex" flexDirection="column" gap="8">
        <Text textStyle="heading/h2">
          <strong>Automate everything</strong> as a service
        </Text>
        <Text>
          Mobile Continuous Integration and Delivery for your whole team, with dozens of integrations
          {!isMobile ? <br /> : ' '}
          for your favourite services.
        </Text>
      </ContentWrapper>
    </Box>
  );
};

type PublicBuildPageProps = PageProps;

const PublicBuildPage = ({ children, withoutFooter, ...rest }: PublicBuildPageProps & { withoutFooter?: boolean }) => {
  return (
    <Page {...rest}>
      <PublicBuildHeader />
      <PublicBuildBanner />
      <Box as="main" display="flex" flexDirection="column" flexGrow={1}>
        {children}
      </Box>
      {!withoutFooter && <InternalFooter />}
    </Page>
  );
};

export default PublicBuildPage;
